import TableCellLoading from './tableCell.component';

export default TableCellLoading;